/* global axios */
import ApiClient from './ApiClient';

class UazapiAPI extends ApiClient {
  constructor() {
    super('uazapi/instances', { accountScoped: true, apiVersion: 'v2' });
  }

  // O controller espera os campos sob a chave `uazapi_instance`.
  create(data) {
    return axios.post(this.url, { uazapi_instance: data });
  }

  fetchStatus(id) {
    return axios.get(`${this.url}/${id}/status`);
  }

  reconnect(id) {
    return axios.post(`${this.url}/${id}/reconnect`);
  }
}

export default new UazapiAPI();
